import * as React from "react";
import { SVGProps } from "react";
function SvgFileTypeXlsIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 29H6v-9h2v7h16v-7h2v9ZM6 2h20v9h-2V4H8v7H6V2Z"
        fill="#169709"
      />
      <path
        d="M10.015 15.697 8.295 12.7H9.7l1.098 1.962 1.098-1.962h1.368l-1.71 2.97 1.89 3.33H12.03l-1.27-2.286L9.485 19H8.116l1.899-3.303Zm4.292-2.997h1.287v5.229h2.78V19h-4.067v-6.3Zm6.948 6.381c-.42 0-.78-.042-1.08-.126-.3-.09-.546-.216-.738-.378a1.596 1.596 0 0 1-.432-.603 2.166 2.166 0 0 1-.153-.783h1.296c.012.246.096.438.252.576.162.138.447.207.855.207s.693-.063.855-.189a.614.614 0 0 0 .252-.504.738.738 0 0 0-.063-.315.594.594 0 0 0-.225-.252 2.081 2.081 0 0 0-.432-.207 6.277 6.277 0 0 0-.684-.198 5.512 5.512 0 0 1-.873-.288 2.388 2.388 0 0 1-.603-.396 1.408 1.408 0 0 1-.36-.522 1.985 1.985 0 0 1-.117-.711c0-.264.045-.504.135-.72.09-.216.228-.402.414-.558.186-.156.42-.276.702-.36.282-.09.615-.135 1-.135.767 0 1.331.168 1.691.504.366.336.555.789.567 1.359h-1.287c-.012-.234-.093-.417-.243-.549-.144-.138-.387-.207-.729-.207-.342 0-.588.063-.738.189a.597.597 0 0 0-.225.477c0 .114.021.213.063.297a.67.67 0 0 0 .225.225c.102.066.237.129.405.189.168.054.378.111.63.171.36.09.666.195.918.315.258.114.468.249.63.405.168.156.291.339.37.549.077.21.116.456.116.738 0 .27-.048.516-.144.738a1.45 1.45 0 0 1-.432.567 2.122 2.122 0 0 1-.747.369c-.3.084-.657.126-1.07.126Z"
        fill="#169709"
      />
    </svg>
  );
}
export default SvgFileTypeXlsIcon;
